import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';

import { FeatureFlag, FeatureFlagsMap } from '../types';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetch(): Observable<FeatureFlagsMap> {
    return this.httpApi.get('/features').pipe(
      map(({ features }) =>
        Object.values(FeatureFlag).reduce((acc, value) => {
          acc[value] = (features || []).includes(value);
          return acc;
        }, <FeatureFlagsMap>{}),
      ),
    );
  }
}
